import { render, staticRenderFns } from "./receiveCalling.vue?vue&type=template&id=0c33c5cf&scoped=true"
import script from "./receiveCalling.vue?vue&type=script&lang=js"
export * from "./receiveCalling.vue?vue&type=script&lang=js"
import style0 from "./receiveCalling.vue?vue&type=style&index=0&id=0c33c5cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c33c5cf",
  null
  
)

export default component.exports